@if (!(isInitialLoading$ | async)) {
  <article [ngClass]="{ 'full-screen': isFullScreen$ | async }">
    <header>
      <h2 class="modal-title pull-left mr-4">
        {{ 'BATCH_MAILING.BATCHES_TAB.CREATE_MODAL.TITLE' | translate }}
      </h2>

      <a
        class="filter-button azure pointer"
        type="button"
        (click)="toggleFullScreen()"
      >
        <span
          class="filter-button-icon fullscreen-btn"
          [inlineSVG]="
            '../assets/img/icons/fullscreen-' +
            ((isFullScreen$ | async) ? 'off' : 'on') +
            '.svg'
          "
        ></span>
        <span>
          {{
            ((isFullScreen$ | async) ? 'FULLSCREEN_OFF' : 'FULLSCREEN_TOOLTIP')
              | translate
          }}
        </span>
      </a>
    </header>

    <app-batch-mailing-form
      class="batch-mailing-form"
      [batch]="batch$ | async"
      [batchMailingData]="batchMailingData$ | async"
      [batchProperties]="batchProperties$ | async"
    />

    @if (!batchProperties?.isPartialReceipt) {
      <section
        class="form-control full-width duplicate-filled-data form-control--sm lh-1 mb-4"
      >
        <div class="checkbox">
          <input
            type="checkbox"
            id="selectAllControl"
            [formControl]="duplicateControl"
          />
          <label for="selectAllControl">
            <div class="checkbox__el"></div>
            <div class="checkbox__desc">
              <p class="h5">
                {{
                  'BATCH_MAILING.BATCHES_TAB.CREATE_MODAL.DUPLICATE_ITEMS'
                    | translate
                }}
              </p>
            </div>
          </label>
        </div>
      </section>
    }

    @if (duplicateControl.value) {
      <div class="duplicates-count-control">
        <div class="dropdown" dropdown>
          <button
            dropdownToggle
            type="button"
            class="dropdown-toggle"
            aria-controls="dropdown-basic"
          >
            {{ duplicatesCountControl.value }} <span class="caret"></span>
          </button>
          <ul
            *dropdownMenu
            class="dropdown-menu"
            role="menu"
            aria-labelledby="button-basic"
          >
            @for (count of duplicatesCountOptions; track count) {
              <li role="menuitem">
                <a
                  class="dropdown-item"
                  (click)="duplicatesCountControl.setValue(count)"
                >
                  {{ count }}
                </a>
              </li>
            }
          </ul>
        </div>
        <label>
          {{
            'BATCH_MAILING.BATCHES_TAB.CREATE_MODAL.DUPLICATE_COUNT' | translate
          }}
        </label>
      </div>
    }

    <footer class="footer">
      <button type="button" class="button button--outlined" (click)="back()">
        {{ 'BACK' | translate }}
      </button>

      <div class="footer-buttons-block">
        @if (!batchProperties?.isPartialReceipt) {
          <button
            type="button"
            class="button button--outlined"
            [disabled]="isBatchMailingProcessing$ | async"
            (click)="submit(true)"
          >
            {{
              'BATCH_MAILING.BATCHES_TAB.CREATE_MODAL.SAVE_WITHOUT_HIDING'
                | translate
            }}
          </button>
        }

        <button
          class="button button--filled button--shadow"
          type="button"
          [disabled]="isBatchMailingProcessing$ | async"
          (click)="submit()"
        >
          {{ 'ADD' | translate }}
        </button>
      </div>
    </footer>
  </article>
} @else {
  <main class="text-secondary text-center">
    <div class="spinner-border spinner-border-lg" role="status">
      <span class="sr-only">{{ 'LOADING' | translate }}</span>
    </div>
  </main>
}
